import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { ZClassUnsafe } from "src/business/classes";
import {
  ZSecSpecRow,
  zSecSpecRow,
} from "src/business/specification/ZSecSpecRow";
import { onError } from "src/common/onError";
import { classSystemKeys } from "src/common/systemKey";
import { MForm } from "src/components/MForm";
import {
  MfErrorsListStore,
  MfErrorsListView,
} from "src/components/MForm/components/MfErrorsListView";
import { findDataNode } from "src/components/MForm/formNav/findDataNode";
import { MFormStore } from "src/components/MForm/MFormStore";
import { PageSubheader } from "src/components/PageSubheader";

import * as styles from "./ClassCardMForm.module.less";

type PropsClassCardMForm = {
  title: React.ReactNode;
  extraButtons?: React.ReactNode | React.ReactNode[];
  save(): Promise<ZClassUnsafe>;
  onSuccess?(result: ZClassUnsafe): void;
  form: MFormStore;
  errorsStore: MfErrorsListStore;
  okText: string;
  onSecondarySpecsChanged(newList: ZSecSpecRow[]): void;
  readOnly?: boolean;
};

export const ClassCardMForm: React.FC<PropsClassCardMForm> = observer(
  (props) => {
    const {
      title,
      extraButtons,
      form,
      okText,
      save,
      onSuccess,
      onSecondarySpecsChanged,
      readOnly,
      errorsStore,
    } = props;
    const onFinish = (): void => {
      form
        .onFinish(save)
        .then((res) => {
          if (!(res instanceof Error)) onSuccess?.(res);
        })
        .catch(onError);
    };
    const onChange = () => {
      const idSecondSpecs = classSystemKeys.secondarySpecs;
      if (form.lastChanged.has(idSecondSpecs)) {
        const node = findDataNode(form.root, [idSecondSpecs]);
        if (node) {
          try {
            onSecondarySpecsChanged(zSecSpecRow.array().parse(node.value));
          } catch (e) {
            onError(e);
          }
        }
      }
    };
    return (
      <div className={styles.mainBox}>
        <PageSubheader title={title}>
          {form.isChanged && "*"}
          {extraButtons}
          {!readOnly && (
            <Button type="primary" onClick={onFinish} loading={form.saving}>
              {okText}
            </Button>
          )}
        </PageSubheader>
        <MForm store={form} onChange={onChange} />
        <MfErrorsListView store={errorsStore} />
      </div>
    );
  },
);
